import script from "./VolumeCandles.vue?vue&type=script&lang=js"
export * from "./VolumeCandles.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__